import React from 'react';
import PropTypes from 'prop-types';

interface MarqueeComponentProps {
    texts: { name: string, notificationid: string }[];
    onTextClick: (notificationid: string) => void;
}

const MyMarquee: React.FC<MarqueeComponentProps> = ({
    texts,
    onTextClick
}) => {

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {texts.map((text, index) => (
                <React.Fragment key={text.notificationid}>
                    <span
                        onClick={() => onTextClick(text.notificationid)}
                        style={{ cursor: 'pointer', marginRight: '20px', color: "blue" }}
                    >
                        {text.name}
                    </span>
                    {index < texts.length - 1 && <span style={{ marginRight: '20px' }}> | </span>}
                </React.Fragment>
            ))}
        </div>
    );
};

MyMarquee.propTypes = {
    texts: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        notificationid: PropTypes.string.isRequired
    }).isRequired).isRequired,
    onTextClick: PropTypes.func.isRequired
};

export default MyMarquee;
